import { render, staticRenderFns } from "./Tenant.vue?vue&type=template&id=dbca99b2&scoped=true&"
import script from "./Tenant.vue?vue&type=script&lang=ts&"
export * from "./Tenant.vue?vue&type=script&lang=ts&"
import style0 from "./Tenant.vue?vue&type=style&index=0&id=dbca99b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbca99b2",
  null
  
)

export default component.exports